import React, { Component } from "react";
import { Stage, Layer, Rect, Text } from "react-konva";

const WIDTH = 650;
const HEIGHT = 140;

export class KenoPayoutBar extends Component {
  getPayoutInfo = () => {
    const { selectedCount } = this.props;

    // Fake example logic (replace with actual game logic)
    const winChance = selectedCount > 0 ? (selectedCount / 40 * 100).toFixed(1) + "%" : "-";
    const payout = selectedCount > 0 ? (2 + selectedCount * 0.5).toFixed(2) + "x" : "-";
    const stake = 1.00; // assume $1 stake for now
    const profit = selectedCount > 0 ? ((stake * (2 + selectedCount * 0.5)) - stake).toFixed(2) : "-";

    return { stake, winChance, payout, profit };
  };

  render() {
    const { stake, winChance, payout, profit } = this.getPayoutInfo();

    // Dynamic positions and sizes
    const columnWidth = WIDTH / 4;
    const titleFontSize = HEIGHT * 0.12; // e.g., 12% of height
    const valueFontSize = HEIGHT * 0.16;
    const topMargin = HEIGHT * 0.2;

    return (
      <Stage width={WIDTH} height={HEIGHT}>
        <Layer>
          <Rect
            x={0}
            y={0}
            width={WIDTH}
            height={HEIGHT}
            fill="#2c3e50"
            cornerRadius={HEIGHT * 0.07}
            shadowBlur={5}
            shadowOpacity={0.2}
          />

          <Text text="Stake" x={columnWidth * 0 + 20} y={topMargin} fill="#fff" fontSize={titleFontSize} />
          <Text text={`$${stake}`} x={columnWidth * 0 + 20} y={topMargin + titleFontSize + 4} fill="#f1c40f" fontSize={valueFontSize} />

          <Text text="Win Chance" x={columnWidth * 1 + 20} y={topMargin} fill="#fff" fontSize={titleFontSize} />
          <Text text={winChance} x={columnWidth * 1 + 20} y={topMargin + titleFontSize + 4} fill="#f1c40f" fontSize={valueFontSize} />

          <Text text="Payout" x={columnWidth * 2 + 20} y={topMargin} fill="#fff" fontSize={titleFontSize} />
          <Text text={payout} x={columnWidth * 2 + 20} y={topMargin + titleFontSize + 4} fill="#f1c40f" fontSize={valueFontSize} />

          <Text text="Profit" x={columnWidth * 3 + 20} y={topMargin} fill="#fff" fontSize={titleFontSize} />
          <Text
            text={`$${profit}`}
            x={columnWidth * 3 + 20}
            y={topMargin + titleFontSize + 4}
            fill={profit > 0 ? "#2ecc71" : "#e74c3c"}
            fontSize={valueFontSize}
          />
        </Layer>
      </Stage>
    );
  }
}

export default KenoPayoutBar;
